import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./FabHomepage.css";

function FabHomepage({ pageData }) {
 const navigate = useNavigate();
 const [selectedImage, setSelectedImage] = useState(null);

 const organization = pageData?.organization || {};
 const page = pageData?.page || {};
 const settings = pageData?.settings || {};
 const content = page?.content || {};

 const name = organization.name || "FAB";
 const themeMode = settings.theme_mode === "light" ? "light" : "dark";

 const heroTitle = content.hero_title || name || "FAB";
 const heroSubtitle =
  content.hero_subtitle || "Competition . Community . Camaraderie";
 const heroButtonLabel = content.hero_button_label || "EXPLORE";
 const heroButtonLink = content.hero_button_link || "/fastactionbasketball/leagueInfo";

 const heroImage = content.hero_image_url || "/fabHomepageImage.jpg";
 const galleryImages = Array.isArray(content.gallery_images) && content.gallery_images.length
  ? content.gallery_images
  : ["/1.jpg", "/2.jpg", "/3.jpg", "/4.jpg", "/5.jpg", "/6.jpg", "/7.jpg", "/8.jpg"];

 const introText =
  content.intro_text ||
  "Fast Action Basketball is Southern California's Premier Adult League. Join us for an electrifying blend of camaraderie, fierce competition, and vibrant community.";

 const sectionTwoText =
  content.section_two_text ||
  "In the winter of 1984, the Fast Action Basketball League was founded with the inception of the Southern California 3-on-3 Indoor Tournament. Hosted at the Los Angeles Forum, the tournament attracted over 200 teams hailing across Los Angeles and Orange County. From this humble beginning, Fast Action ignited, expanding to multiple locations and accommodating over 350 teams every week, year-round, across three seasons annually.";

 const sectionThreeText =
  content.section_three_text ||
  "To date we have hosted over 35,000 adult basketball games and we’re still striving to provide quality competition autographed with excellence one game at a time.";

 const sectionFourLines =
  Array.isArray(content.section_four_lines) && content.section_four_lines.length
   ? content.section_four_lines
   : [
    "Over four decades later, we remain proudly family-owned and operated, maintaining our commitment to fostering a sense of community and camaraderie on and off the court.",
    "Come join us, and let us show you true competition,",
    "vital community connection, and inclusive service.",
    "We are FAB.",
   ];

 const secondHeroImage = content.second_hero_image_url || "/thirdHomepageImage.jpg";
 const thirdHeroImage = content.third_hero_image_url || "/fourthHomepageImage.jpg";
 const fourthHeroImage = content.fourth_hero_image_url || "/fifthHomepageImage.jpg";

  const handleHeroClick = () => {
    const rawLink = String(heroButtonLink || "").trim();
    if (!rawLink) return;

    const isExternal =
      rawLink.startsWith("http://") ||
      rawLink.startsWith("https://");

    const looksLikeDomain =
      !rawLink.startsWith("/") &&
      rawLink.includes(".") &&
      !rawLink.startsWith("./") &&
      !rawLink.startsWith("../");

    if (isExternal) {
      window.open(rawLink, "_blank", "noopener,noreferrer");
      return;
    }

    if (looksLikeDomain) {
      window.open(`https://${rawLink}`, "_blank", "noopener,noreferrer");
      return;
    }

    navigate(rawLink.startsWith("/") ? rawLink : `/${rawLink}`);
  };

 return (
  <div className={`fab-homepage ${themeMode}`}>
   <div
    className="fab-hero"
    style={{ backgroundImage: `url(${heroImage})` }}
   >
    <section className="fab-hero-content">
     <h1>{heroTitle}</h1>
     <h2>{heroSubtitle}</h2>
     {heroButtonLink ? (
      <button onClick={handleHeroClick}>{heroButtonLabel}</button>
     ) : null}
    </section>
   </div>

   <section className="fab-content-section">
    <div className="image-grid">
     {galleryImages.map((src, index) => (
      <img
       key={index}
       src={src}
       alt={`${name} ${index + 1}`}
       onClick={() => setSelectedImage(src)}
       className="grid-img"
      />
     ))}
    </div>

    <p>
     <strong>{name}</strong> {introText.replace(/^Fast Action Basketball\s*/i, "")}
    </p>
   </section>

   <div
    className="second-fab-hero"
    style={{ backgroundImage: `url(${secondHeroImage})` }}
   >
    <section className="second-fab-hero-content">
     <p>{sectionTwoText}</p>
    </section>
   </div>

   <div
    className="third-fab-hero"
    style={{ backgroundImage: `url(${thirdHeroImage})` }}
   >
    <section className="third-fab-hero-content">
     <p>{sectionThreeText}</p>
    </section>
   </div>

   <div
    className="fourth-fab-hero"
    style={{ backgroundImage: `url(${fourthHeroImage})` }}
   >
    <section className="fourth-fab-hero-content">
     {sectionFourLines.map((line, index) => (
      <p key={index}>{line}</p>
     ))}
    </section>
   </div>

   {selectedImage && (
    <div className="modal-backdrop" onClick={() => setSelectedImage(null)}>
     <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <img src={selectedImage} alt="Full View" />
     </div>
    </div>
   )}
  </div>
 );
}

export default FabHomepage;